import { Injectable, inject } from '@angular/core';
import { RequestBuilder } from '@hereisyourgitanton/crm-api2';
import { HttpClient, HttpParams } from '@angular/common/http';
import { TradingProcedureResponseDto } from '../schemas/trading-procedure-responses/trading-procedure-response.dto';
import { CreateTradingProcedureRequestDto } from '../schemas/trading-procedure-requests/create-trading-procedure-request.dto';
import { UpdateTradingProcedureRequestDto } from '../schemas/trading-procedure-requests/update-trading-procedure-request.dto';
import { TRADGINE_DATA_API_BASE_URL } from '../api-base-url.token';
import { CancelTradingProcedureRequestDto } from '../schemas/trading-procedure-requests/cancel-trading-procedure-request.dto';
import { PublishTradingProcedureRequestDto } from '../schemas/trading-procedure-requests/publish-trading-procedure-request.dto';

@Injectable({ providedIn: 'root' })
export class TradingProcedureAdminApi {
    private readonly builder = new RequestBuilder(inject(HttpClient));
    private readonly controllerUrl = `${inject(TRADGINE_DATA_API_BASE_URL)}/TradingProcedureAdmin`;

    getAll() {
        return this.builder
            .url(`${this.controllerUrl}/getAll`)
            .get()
            .json<TradingProcedureResponseDto[]>()
            .build()
            .send();
    }

    getById(id: number) {
        return this.builder
            .url(`${this.controllerUrl}/getById`)
            .get()
            .json<TradingProcedureResponseDto>()
            .withHttpParams(new HttpParams().set('id', id))
            .build()
            .send();
    }

    create(payload: CreateTradingProcedureRequestDto) {
        return this.builder
            .url(`${this.controllerUrl}/create`)
            .post(payload)
            .json<TradingProcedureResponseDto>()
            .build()
            .send();
    }

    delete(id: number) {
        return this.builder
            .url(`${this.controllerUrl}/delete`)
            .delete()
            .text()
            .withHttpParams(new HttpParams().set('id', id))
            .build()
            .send();
    }

    publish(payload: PublishTradingProcedureRequestDto) {
        return this.builder
            .url(`${this.controllerUrl}/publish`)
            .post(payload)
            .json<TradingProcedureResponseDto>()
            .build()
            .send();
    }

    update(payload: UpdateTradingProcedureRequestDto) {
        return this.builder
            .url(`${this.controllerUrl}/update`)
            .put(payload)
            .json<TradingProcedureResponseDto>()
            .build()
            .send();
    }

    cancel(payload: CancelTradingProcedureRequestDto) {
        return this.builder
            .url(`${this.controllerUrl}/cancel`)
            .post(payload)
            .json<TradingProcedureResponseDto>()
            .build()
            .send();
    }
}
